import { Typography, Grid, Container, Box } from "@mui/material";

const ProjectsSection = () => (
    <Box id="projects" style={{ marginTop: 15, backgroundColor: "#2A2A2B", color: "white" }}>
        <Container sx={{ padding: { xs: "4rem 2rem", md: "4rem 0" }, textAlign: "left" }}>
            <Grid container>
                <Grid item xs={12} md={6} style={{ padding: "1rem" }}>
                    <Typography variant="h2" marginBottom={3}>
                        OUR LATEST PROJECT
                    </Typography>
                    <Typography variant="h3" marginBottom={4}>
                        Aston Martin Residences: Designed for living <br /> beautifully
                    </Typography>
                    <Typography variant="body1" paragraph>
                        The prestigious <Typography component="span" fontSize={'23px'} style={{ fontWeight: "bold" }}>Aston Martin Residences</Typography> is a testament to our commitment to excellence.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We applied our expertise by managing chief builders, coordinating their work, and ensuring <Typography component="span" fontSize={'23px'} style={{ fontWeight: "bold" }}>quality and safety standards</Typography>. Meticulously maintained the project budget, tracked expenses, scheduled subcontractors, and adhered to all regulatory and safety requirements.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        This comprehensive management ensured the seamless execution of the project, delivering <Typography component="span" fontSize={'23px'} style={{ fontWeight: "bold" }}>a luxurious and high-quality residential experience</Typography>.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box style={{ height: "100%", backgroundImage: "url('/img/building.png')", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center" }} />
                </Grid>
            </Grid>
        </Container>
    </Box>
);

export default ProjectsSection;